/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-20T12:07:15.72
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getOrgUserManageEditInit,
	getOrgUserManageView
} from '@api/systemmanage/OrgUserManage';

import {
listAuthFuncRoleManageInit,
listAuthFuncRoleManageByAuthorizations,
deleteAuthFuncRoleManage
} from '@api/systemmanage/AuthFuncRoleManage';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getOrgUserManageEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getOrgUserManageEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getOrgUserManageView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getOrgUserManageView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
